<script setup lang="ts">
// パンくず
useBreadcrumbs([
  { name: "TOP", path: "/" },
  { name: "施工例", path: "/sekou" },
]);

useScrollTop(true);
</script>

<template>
  <SekouWrapper>
    <div class="wrapper">
      <TextPageTitle class="hidden pc:block">施工例</TextPageTitle>
      <div class="flex flex-col pc:flex-row">
        <SekouMenu class="pc:w-1/4" />
        <SekouList class="pc:w-3/4" />
      </div>
    </div>
  </SekouWrapper>
</template>
